module.exports = __webpack_public_path__ + "img/study-mode-faq-5.6ff49c98.png";